<template>
  <div
    id="kesfet-menu"
    class="flex flex-wrap sm:flex-col sm:items-end z-3"
    :class="[isMobile && 'gap-2 z-130 sticky top-0 pt-4 px-4 bg-[#F7F8FB] w-full justify-between']"
  >
    <OButton
      id="takip"
      pure
      class="
        mainFilter
        rounded-lg
        sm:rounded-xl
        px-2
        sm:pl-[13px] sm:pr-4
        py-2.5
        text-sm
        sm:text-md
        text-left
        sm:min-w-[155px] sm:w-max sm:h-9
        h-[50px]
        flex-1
        sm:flex-none
        justify-center
        sm:justify-start
      "
      @click="selectFilter('takip')"
    >
      <div class="icon-kesfet" :class="[selectedMainFilter === 'takip' ? 'bg-white' : 'icon-kesfet-bg']"></div>
      <p>Takip Ettiklerim</p>
    </OButton>
    <slot />
    <div v-if="!isMobile" class="border-t border-[#000]/[.1] w-full mb-4 mt-2"></div>

    <OButton
      id="trend"
      pure
      class="
        mainFilter
        rounded-lg
        sm:rounded-xl
        p-3
        sm:px-4 sm:py-2.5
        text-sm
        sm:text-md sm:min-w-[155px] sm:h-9
        h-[50px]
        flex-1
        sm:flex-none
        justify-center
        sm:justify-start
      "
      @click="selectFilter('trend')"
    >
      Trendler
    </OButton>
    <OButton
      id="sana-ozel"
      pure
      class="
        mainFilter
        rounded-lg
        sm:rounded-xl
        p-3
        sm:px-4 sm:py-2.5
        text-sm
        sm:text-md sm:min-w-[155px] sm:h-9
        h-[50px]
        flex-1
        sm:flex-none
        justify-center
        sm:justify-start
      "
      @click="selectFilter('sana-ozel')"
    >
      Sana Özel
    </OButton>
    <OButton
      id="en-son"
      pure
      class="
        mainFilter
        rounded-lg
        sm:rounded-xl
        p-3
        sm:px-4 sm:py-2.5
        text-sm
        sm:text-md sm:min-w-[155px] sm:h-9
        h-[50px]
        flex-1
        sm:flex-none
        justify-center
        sm:justify-start
      "
      @click="selectFilter('en-son')"
    >
      En Son İçerikler
    </OButton>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, inject } from '@nuxtjs/composition-api';
import { OBreadcrumb, OLoading, OButton } from '@/modules/common/components/ui';
import { useDevice } from '@/composables/useDevice';
import ListArticleCard from '~/modules/card/templates/common/ListArticleCard';
import DailyEmojile from '~/modules/oyun/components/previousGames/DailyEmojile.vue';
import { localStore } from '~/modules/common/utils/localStorageUtils';

export default defineComponent({
  head: {
    bodyAttrs: {
      class: 'bg-[#f7f8fb] o-ps-global',
    },
  },
  components: {
    OLoading,
    OBreadcrumb,
    OButton,
    ListArticleCard,
    DailyEmojile,
  },
  setup(props, { emit }) {
    const { isMobile } = useDevice();
    const selectedMainFilter = ref('takip');
    const mainFilters = ref([]);
    const { lastCategory } = inject('lastCategory');

    const selectFilter = (_id, sendEvent = true) => {
      selectedMainFilter.value = _id;
      mainFilters.value.forEach((filter) => {
        if (filter.id === _id) {
          if (sendEvent) {
            window.dataLayer.push({
              event: 'filtered',
              event_category: filter.textContent.trim(), // Takip Ettiklerim, Trendler, Sana Özel vs. alanındaki değerler gelecek.
              event_action: 'Clicked',
              event_label: selectedMainFilter.value === 'takip' ? lastCategory() : filter.textContent.trim(), // Hangi filtre seçildiyse o bilgi gelecek. Eğer Takip Ettiklerim haricinde bir filtre seçildiyse, örneğin Trendler gibi, o zaman Trendler değeri buraya da gelecek.
            });
          }

          filter.classList.add('mainSelected');
        } else filter.classList.remove('mainSelected');
      });
      emit('getArticles', _id);
      localStore.setItem('o-main-filter', selectedMainFilter.value);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    onMounted(() => {
      const filter = localStore.getItem('o-main-filter');
      if (filter) selectedMainFilter.value = filter;

      mainFilters.value = document.querySelectorAll('.mainFilter');
      selectFilter(selectedMainFilter.value, false);
    });

    return {
      selectFilter,
      selectedMainFilter,
      isMobile,
    };
  },
});
</script>
<style lang="scss" scoped>
.mainFilter {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  color: #424242;
  font-weight: 400;
  background: #fff;
  border: 1.5px solid #e2e5ed;
  margin-bottom: 8px;
}
.mainSelected {
  background: linear-gradient(180deg, #9456e4 0%, #5962f4 100%);
  color: #fff;
  border: none;
}

.icon-kesfet {
  display: inline-block;
  width: 18px;
  height: 18px;
  -webkit-mask: url('@/static/svg/icon-kesfet.svg') no-repeat center;
  mask: url('@/static/svg/icon-kesfet.svg') no-repeat center;
  -webkit-mask-size: cover;
  mask-size: cover;
}
.icon-kesfet-bg {
  background: linear-gradient(180deg, #9456e4 0%, #5962f4 100%);
}
</style>
